// extracted by mini-css-extract-plugin
export default {"lineContainer":"CustomersList_lineContainer__0znW0","customersListContainer":"CustomersList_customersListContainer__Q45ds","emptyMessage":"CustomersList_emptyMessage__rZgSm"};